<template>
  <div class="side-menu-container">
    <el-menu
      :default-active="activeIndex"
      :collapse="false"
      mode="vertical"
      background-color="#2f344d"
      text-color="#fff"
      active-text-color="#409EFF"
      :default-openeds="defaultOpeneds"
    >
      <template v-for="item in menuList" :key="item.name">
        <el-sub-menu v-if="item?.sub?.length" :index="item.name">
          <template #title>{{ item.name }}</template>
          <el-menu-item :index="i.name" v-for="i in item.sub" :key="i.name" @click="jump(i)">
            {{ i.name }}
          </el-menu-item>
        </el-sub-menu>

        <el-menu-item v-else :index="item.name" @click="jump(item)">
          {{ item.name }}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { rootStore } from '@/store/rootStore';

const store = rootStore();
const { isManager, isBackendManagerOrDeveloper, isBackendPermissionAllocator, userInfo } = storeToRefs(store);

const menuList = computed(() => {
  let tmp = [
    {
      name: '后台入口',
      path: '/',
    },
  ];

  if (isManager.value) {
    tmp = tmp.concat([
      {
        name: '用户管理',
        path: '/userManage',
      },
      {
        name: '后台管理',
        path: '/backendManage',
      },
      {
        name: '权限管理',
        sub: [
          {
            name: '用户权限',
            path: '/userAuth',
          },
          {
            name: '权限点',
            path: '/pointAuth',
          },
        ],
      },
      {
        name: '日志管理',
        sub: [
          {
            name: '登录日志',
            path: '/loginLog',
          },
          {
            name: '接口访问日志',
            path: '/visitLog',
          },
          {
            name: '后台访问日志',
            path: '/backendLog',
          },
          {
            name: '鉴权日志',
            path: '/authLog',
          },
          {
            name: '操作日志',
            path: '/operationLog',
          },
        ],
      },
    ]);
  }
  if (isBackendPermissionAllocator.value) {
    tmp = tmp.concat([
      {
        name: '后台管理',
        path: '/backendManage',
      },
    ]);
  }
  if (isBackendManagerOrDeveloper.value || isBackendPermissionAllocator.value) {
    tmp = tmp.concat([
      {
        name: '权限管理',
        sub: [
          {
            name: '用户权限',
            path: '/userAuth',
          },
          {
            name: '权限点',
            path: '/pointAuth',
          },
        ],
      },
    ]);
  }
  // 触达模块，北洛、多拉、华昱权限开放
  const reachSpecialPermission = ['157329214500000040', '160444810800000090', '161040976100000030'].includes(
    userInfo.value?.id
  );
  if (isManager.value || reachSpecialPermission) {
    tmp = tmp.concat([
      {
        name: '触达管理',
        sub: [
          {
            name: '系统消息',
            path: '/reachMange',
          },
        ],
      },
    ]);
  }
  // 根据name去重
  return [...new Map(tmp.map((item) => [item.name, item])).values()];
});

const defaultOpeneds = ['权限管理', '日志管理', '触达管理'];

const router = useRouter();
const route = useRoute();

const activeIndex = computed(() => {
  return menuList.value
    .map((i) => i?.sub || i)
    .flat()
    .find((i) => i.path === route.path)?.name;
});
const jump = (item) => {
  if (item?.sub?.length > 0) {
    return false;
  }
  router.push(item.path);
};
</script>

<style lang="less">
.side-menu-container {
  padding-bottom: 10px;
}
</style>
